import { createFileRoute } from '@tanstack/react-router';

// /settings on its own is a real destination below md, where the sidebar owns the whole screen.
// Above md the layout redirects to the first page — see SettingsLayout.
export const Route = createFileRoute('/settings/')({
    component: () => null,
});
